import {
    ServerCapabilities,
    ServerCapabilityNames,
    ServerCapabilityRequirement,
    ServerCapabilityStats,
} from '../../../domain/ServerCapabilities'
import { ApplicationState } from '../../ApplicationState'
import { getServerCapabilityState } from '../V2State'

export interface ServerCapabilityState {
    byCapability: ServerCapabilities
    loaded: boolean
}
export const getServerCapabilityRequirements = (
    state: ApplicationState,
    capability: ServerCapabilityNames,
): ServerCapabilityRequirement[] | null => {
    const cap = getServerCapabilityState(state).byCapability[capability] || null

    return cap ? Object.keys(cap.requirements).map(requirement => cap.requirements[requirement]) : null
}

export const getServerCapability = (
    state: ApplicationState,
    capability: ServerCapabilityNames,
    environment: string,
    service: string,
): ServerCapabilityStats | null => {
    const cap = getServerCapabilityState(state).byCapability[capability] || null

    if (!cap) {
        return null
    }

    if (!(environment in cap.servers) || !(service in cap.servers[environment])) {
        return null
    }

    return cap.servers[environment][service]
}
export const areServerCapabilitiesLoaded = (state: ApplicationState): boolean => getServerCapabilityState(state).loaded || false
